module.exports = __webpack_public_path__ + "static/media/document-signed-icon.1931d13a.svg";